import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { BuildingIcon, FileCheck2Icon, HistoryIcon, HomeIcon, MenuIcon, SlidersHorizontalIcon, TargetIcon, TrendingUpIcon, UploadCloudIcon, UserRoundIcon, UsersIcon, WalletCardsIcon, XIcon } from 'lucide-react';
import { loanOfficer } from '../../data/officer';
import { PersonaSwitcher } from './PersonaSwitcher';
interface NavItemConfig {
  to: string;
  label: string;
  icon: typeof HomeIcon;
  badge: string | null;
  end: boolean;
}
const navSections: {
  title: string;
  items: NavItemConfig[];
}[] = [{
  title: 'My activity',
  items: [{
    to: '/',
    label: 'Perfect Day',
    icon: HomeIcon,
    badge: null,
    end: true
  }, {
    to: '/progress',
    label: 'My Progress',
    icon: TrendingUpIcon,
    badge: null,
    end: false
  }, {
    to: '/plan',
    label: 'My Perfect Week',
    icon: SlidersHorizontalIcon,
    badge: null,
    end: false
  }]
}, {
  title: 'Business development',
  items: [{
    to: '/prospects',
    label: 'Realtor Prospects',
    icon: TargetIcon,
    badge: '7',
    end: false
  }, {
    to: '/realtors',
    label: 'My Realtors',
    icon: BuildingIcon,
    badge: '7',
    end: false
  }, {
    to: '/past-clients',
    label: 'Past Clients',
    icon: HistoryIcon,
    badge: '3',
    end: false
  }, {
    to: '/import',
    label: 'Import Data',
    icon: UploadCloudIcon,
    badge: null,
    end: false
  }]
}, {
  title: 'Pipeline',
  items: [{
    to: '/leads',
    label: 'My Leads',
    icon: UsersIcon,
    badge: '4',
    end: false
  }, {
    to: '/pre-approvals',
    label: 'My Pre-Approvals',
    icon: FileCheck2Icon,
    badge: '3',
    end: false
  }, {
    to: '/loans',
    label: 'My Loans',
    icon: WalletCardsIcon,
    badge: null,
    end: false
  }]
}];
export function PortalShell({
  children
}: {
  children: React.ReactNode;
}) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setMobileNavOpen(false), [location.pathname]);
  return <div className="flex min-h-screen w-full bg-[#f7f8fa]" data-id="element-525" data-mp="36uj8l2d1ujwy">
      <nav aria-label="Portal" className="sticky top-0 hidden h-screen w-60 shrink-0 flex-col border-r border-navy-100 bg-white lg:flex" data-id="element-526" data-mp="2s77yz60fh9zh">
        <div className="shrink-0 px-4 py-5" data-id="element-527" data-mp="2j6rv3vfrw0u3">
          <p className="text-sm font-bold text-navy-900" data-id="element-528" data-mp="2j7t9o9vzz5gk">Partner Workspace</p>
          <p className="mt-0.5 text-xs text-navy-500" data-id="element-529" data-mp="2n7vakgtwruus">Reach Home Loans</p>
        </div>
        <div className="flex-1 overflow-y-auto px-3 pb-4" data-id="element-530" data-mp="298vmpbe7zjzo">
          <NavSections data-id="element-531" data-mp="299doenjniqez" />
        </div>
        <div className="mt-auto shrink-0 space-y-3 border-t border-navy-100 p-4" data-id="element-532" data-mp="2e7f7v9kzorqz">
          <PersonaSwitcher data-id="element-533" data-mp="2e9je3y6d22uf" />
          <div className="flex items-center gap-3" data-id="element-534" data-mp="1uldg27h3kfam">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-navy-800 text-xs font-bold text-white" data-id="element-535" data-mp="1unzkhy8oyeom">
              JR
            </span>
            <div className="min-w-0" data-id="element-536" data-mp="24l46ny2jea5f">
              <p className="truncate text-sm font-semibold text-navy-900" data-id="element-537" data-mp="24hzxsne4mq8f">
                {loanOfficer.fullName}
              </p>
              <p className="truncate text-xs text-navy-500" data-id="element-538" data-mp="2dkhhov6b76s9">
                External Loan Officer
              </p>
            </div>
          </div>
        </div>
      </nav>

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-539" data-mp="28jttsiddn629">
        <div className="sticky top-0 z-30 flex items-center justify-between gap-3 border-b border-navy-100 bg-white px-4 py-3 lg:hidden" data-id="element-540" data-mp="2n9j1kwfz68bi">
          <button type="button" onClick={() => setMobileNavOpen(true)} aria-label="Open portal navigation" aria-expanded={mobileNavOpen} className="inline-flex h-11 w-11 items-center justify-center rounded-lg border border-navy-200 text-navy-700" data-id="element-541" data-mp="2idkdzb2h0uc5">
            <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-542" data-mp="ulteu84syycu" />
          </button>
          <p className="text-sm font-bold text-navy-900" data-id="element-543" data-mp="ujqdwt243ktc">Partner Workspace</p>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-navy-800 text-xs font-bold text-white" data-id="element-544" data-mp="zdl7co7ire5m">
            JR
          </span>
        </div>

        {mobileNavOpen ? <div className="fixed inset-0 z-50 lg:hidden" data-id="element-545" data-mp="6pysgjsucn3g">
            <div className="absolute inset-0 bg-navy-900/45" onClick={() => setMobileNavOpen(false)} aria-hidden="true" data-id="element-546" data-mp="bmfg7cw4ozg0" />
            <nav aria-label="Portal" className="relative flex h-full w-72 max-w-[85%] flex-col overflow-y-auto bg-white shadow-panel" data-id="element-547" data-mp="knx61mzc8fhw">
              <div className="flex items-center justify-between px-4 py-4" data-id="element-548" data-mp="1s3jo7wbk84z7">
                <div data-id="element-549" data-mp="1w1hdt098st34">
                  <p className="text-sm font-bold text-navy-900" data-id="element-550" data-mp="1w558w3uc5njy">
                    Partner Workspace
                  </p>
                  <p className="text-xs text-navy-500" data-id="element-551" data-mp="3cjrlnh2xqo1z">Reach Home Loans</p>
                </div>
                <button type="button" onClick={() => setMobileNavOpen(false)} aria-label="Close navigation" className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-navy-500 hover:bg-navy-50" data-id="element-552" data-mp="37sjaoglyiump">
                  <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-553" data-mp="2svs67sxfesq8" />
                </button>
              </div>
              <div className="px-3" data-id="element-554" data-mp="2otf4dflsveyq">
                <NavSections data-id="element-555" data-mp="2ougpye0fzjup" />
              </div>
              <div className="mt-4 px-3" data-id="element-556" data-mp="2jv3uj4vi94gi">
                <PersonaSwitcher data-id="element-557" data-mp="2jw5e5xql6z9u" />
              </div>
              <div className="mt-auto flex items-center gap-3 border-t border-navy-100 p-4" data-id="element-558" data-mp="n2abyhc1madc">
                <UserRoundIcon className="h-5 w-5 text-navy-400" aria-hidden="true" data-id="element-559" data-mp="i3h87gmk5xqd" />
                <div data-id="element-560" data-mp="11716dbrdrq7m">
                  <p className="text-sm font-semibold text-navy-900" data-id="element-561" data-mp="116sv1oawosyj">
                    {loanOfficer.fullName}
                  </p>
                  <p className="text-xs text-navy-500" data-id="element-562" data-mp="s7e3elj06ccg">External Loan Officer</p>
                </div>
              </div>
            </nav>
          </div> : null}

        {children}
      </div>
    </div>;
}
function NavSections() {
  return <div className="space-y-5" data-id="element-563" data-mp="1kwl3vq20pc0c">
      {navSections.map(section => <div key={section.title} data-id="element-564" data-mp="1oxycg7whvtay">
          <p className="px-3 pb-1 text-[11px] font-bold uppercase tracking-wide text-navy-400" data-id="element-565" data-mp="1owvl5yv9foui">
            {section.title}
          </p>
          <ul className="space-y-1" data-id="element-566" data-mp="1fx079mablfqs">
            {section.items.map(item => <li key={item.to} data-id="element-567" data-mp="1fytcqy975tx7">
                <NavItem {...item} data-id="element-568" data-mp="3vnl72s1f49l8" />
              </li>)}
          </ul>
        </div>)}
    </div>;
}
function NavItem({
  to,
  label,
  icon: Icon,
  badge,
  end
}: NavItemConfig) {
  return <NavLink to={to} end={end} className={({
    isActive
  }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold ${isActive ? 'bg-navy-800 text-white' : 'text-navy-700 hover:bg-navy-50 hover:text-navy-900'}`} data-id="element-569" data-mp="3t2x2zcn0tkrh">
      {({
      isActive
    }) => <>
          <Icon className={`h-5 w-5 shrink-0 ${isActive ? 'text-teal-300' : 'text-navy-400'}`} aria-hidden="true" data-id="element-570" data-mp="xt399tqj67k" />
          <span className="flex-1 truncate" data-id="element-571" data-mp="35ex23jvzwdz6">{label}</span>
          {badge ? <span className={`inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-[11px] font-bold tabular-nums ${isActive ? 'bg-white/15 text-white' : 'bg-navy-100 text-navy-600'}`} data-id="element-572" data-mp="3j58xbrnvmsuj">
              {badge}
            </span> : null}
        </>}
    </NavLink>;
}